module.exports = __webpack_public_path__ + "img/06.fc3e8d31.jpg";